module.exports = __webpack_public_path__ + "img/divider_rough_edge_top.78b345ea.svg";